import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { AppConfig } from './data.schema';
import { AppSettings } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private _http: HttpClient, private _user: UserService) {  }
  
  _httpRequest(api: string, load: any, sw: number) {
    let userDevice: string = this._user.isMobile() ? 'Web Access using Mobile phone' : 'Web Access using Desktop/Laptop';

    let result: any;
    switch (sw) {
      case 1:
        let dt = {
          payload: load,
          param1: this._user.getUserID(),
          param2: this._user.getUserKey(),
          param3: 5,
          param4: userDevice,
          param5: this._user.getUserRole(),
          param6: this._user.getUserFullname(),
          param7: this._user.getUserDept(),
          param8: this._user.getUserProgram()
        };
        result = this._http.post(this.baseURL + btoa(api), this._user._convertmessage(((JSON.stringify(dt)))));
        break;
      case 2:
        result = this._http.post(this.baseURL +api, this._user._convertmessage(((JSON.stringify(load)))));
      break;
      case 3:
        let _headers3 = new HttpHeaders({
          'Authorization': `Bearer ${this._user.getUserKey()}`
        });
        result = this._http.post(this.baseURL + api, load, { headers: _headers3 });
      break;
      case 4:
        // result = this._http.post(this.baseURL + btoa(api), this._user._convertmessage((decodeURIComponent(JSON.stringify(dt)))));
        break;
      case 5:
        let _headers = new HttpHeaders({
          'Content-Type': 'text/plain',
          'Authorization': `Bearer ${this._user.getUserKey()}`
        });
          result = this._http.post(this.baseURL +api, this._user._convertmessage(JSON.stringify(load)), { headers: _headers });
      break;
      
      case 6: 
          result = this._http.post(this.baseURL +api, this._user._convertmessage(JSON.stringify(load)));
      break;


      
        
      default: break;
    }
    return result;
  }

  downloadFile(filepath, filename) {
    let userDevice: string = this._user.isMobile() ? 'Web Access using Mobile phone' : 'Web Access using Desktop/Laptop';
    let _headers = new HttpHeaders({
      'Authorization': `Bearer ${this._user.getUserKey()}`
    });
    let dt = {
      payload: { filepath: filepath, filename: filename },
    };

    this._http.post(this.baseURL + 'download', this._user._convertmessage(JSON.stringify(dt)), {headers: _headers, responseType: 'blob' }).subscribe((res) => {
      const url = URL.createObjectURL(res);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
    }, er => {

    })
  }

  public prefix: string = AppSettings.prefix;
  public baseURL: string = AppSettings.baseURL;
  public downloadURL: string = AppSettings.downloadURL;
  public imageURL: string = AppSettings.imageURL;
  public iflURL: string = AppSettings.iflURL;
  public booksURL: string = AppSettings.booksURL;
  public announcementURL: string = AppSettings.announcement;
}
